module.exports = __webpack_public_path__ + "static/media/23.55f69218.mp3";